import { Injectable } from '@angular/core';
import { PurchaseItem } from '../utils/PurchaseItem';

@Injectable({
  providedIn: 'root'
})
export class PermissionPricesService {

    private permissionPrice:Map<string, Number>;
		
		private purchaseItems:Map<string, string>;
		
		constructor() {  
			this.permissionPrice = new Map<string, Number>();			
			this.purchaseItems = new Map<string, string>();
		}
		
		public getPrice( permission:string ):Number{
			return this.permissionPrice[ permission ];
		}
		
		public addPrice( permissionName:string, price:Number):void{
			this.permissionPrice[ permissionName ] = price;
		}
		
		public addPurchaseItem( item:PurchaseItem ): void {
			this.purchaseItems[ item.getName() ] = item;
		}
		
		public getPurchaseItem( name:string ) : PurchaseItem {
			return this.purchaseItems[ name ];
    }
    
  
}
